import { stringify } from 'query-string';
import type { EnrichedFetchOptions, FetchOptions } from './types';

const arrayFormat = 'comma';

export const get = async (
  url: string,
  input?: Record<string, unknown>,
  options?: EnrichedFetchOptions,
) => {
  const forceBodyParams = options?.forceParamsInBody ?? false;
  const queryString = input ? stringify(input, { arrayFormat }) : '';

  const composedUrl =
    !forceBodyParams && input && Object.keys(input).length > 0
      ? `${url}${queryString ? `?${queryString}` : ''}`
      : url;

  return fetch(composedUrl, {
    ...options,
    method: 'GET',
    body: forceBodyParams ? JSON.stringify(input) : undefined,
  });
};

export const post = async (url: string, input: Record<string, unknown>, options: FetchOptions) => {
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(input),
    ...options,
  });
};

export const del = async (
  url: string,
  input: Record<string, unknown>,
  options?: EnrichedFetchOptions,
) => {
  const forceBodyParams = options?.forceParamsInBody ?? false;
  const queryString = input ? stringify(input, { arrayFormat }) : '';

  const composedUrl =
    !forceBodyParams && input && Object.keys(input).length > 0
      ? `${url}${queryString ? `?${queryString}` : ''}`
      : url;

  return fetch(composedUrl, {
    ...options,
    method: 'DELETE',
    body: forceBodyParams ? JSON.stringify(input) : undefined,
  });
};

export const patch = async (url: string, input: Record<string, unknown>, options: FetchOptions) => {
  return fetch(url, {
    ...options,
    method: 'PATCH',
    body: JSON.stringify(input),
  });
};

export const put = async (url: string, input: Record<string, unknown>, options: FetchOptions) => {
  return fetch(url, {
    ...options,
    method: 'PUT',
    body: JSON.stringify(input),
  });
};
